import { Utils } from "@/plugins/utils"

function emptyLine() {
	return {
		dr4lcto: "",
		dr4contad: "",
		dr4contac: "",
		dr4valor: 0,
		dr4histor: "",
		dr4histori: "",
		dr4numarq: "",
	}
}

function isLineEmpty(dr4) {
	return (
		!dr4.dr4contad &&
		!dr4.dr4contac &&
		!dr4.dr4valor &&
		!dr4.dr4histor &&
		!dr4.dr4histori &&
		!dr4.dr4numarq
	)
}

export default {
	namespaced: true,
	state: {
		lstDr4: [emptyLine()],
		loading: false,
	},
	getters: {
		getLstDr4: state => state.lstDr4,
		getLoading: state => state.loading,
		getLstDr4NotEmpty: state => state.lstDr4.filter(dr4 => !isLineEmpty(dr4)),
		getTotalDebit: state =>
			state.lstDr4.reduce((total, dr4) => (dr4.dr4contad ? total + (Number(dr4.dr4valor) || 0) : total), 0),
		getTotalCredit: state =>
			state.lstDr4.reduce((total, dr4) => (dr4.dr4contac ? total + (Number(dr4.dr4valor) || 0) : total), 0),
	},
	mutations: {
		initForm(state) {
			state.lstDr4 = [emptyLine()]
		},
		setLstDr4(state, lstDr4) {
			state.lstDr4 = lstDr4 && lstDr4.length ? [...lstDr4, emptyLine()] : [emptyLine()]
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		removeLine(state, index) {
			state.lstDr4.splice(index, 1)
			if (!state.lstDr4.length || !isLineEmpty(state.lstDr4[state.lstDr4.length - 1])) {
				state.lstDr4.push(emptyLine())
			}
		},
		ensureTrailingEmptyLine(state) {
			let lastLine = state.lstDr4[state.lstDr4.length - 1]
			if (!lastLine || !isLineEmpty(lastLine)) {
				state.lstDr4.push(emptyLine())
			}
		},
		assignNextLcto(state, index) {
			let nextLcto = state.lstDr4.reduce((max, dr4) => Math.max(max, Number(dr4.dr4lcto) || 0), 0) + 1
			state.lstDr4[index].dr4lcto = String(nextLcto).padStart(3, "0")
		},
		appendImportedLines(state, lstImported) {
			lstImported.forEach(item => {
				let index = state.lstDr4.length - 1
				state.lstDr4.splice(index, 0, { ...emptyLine(), dr4valor: item.dr4valor, dr4histori: item.dr4histori })
				this.commit("dr4/assignNextLcto", index)
			})
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		setLstDr4({ commit }, lstDr4) {
			commit("setLstDr4", lstDr4)
		},
		removeLine({ commit }, index) {
			commit("removeLine", index)
		},
		lineChanged({ commit, state }, index) {
			if (!isLineEmpty(state.lstDr4[index]) && !state.lstDr4[index].dr4lcto) {
				commit("assignNextLcto", index)
			}
			commit("ensureTrailingEmptyLine")
		},
		async importBankStatement({ commit, dispatch }, { dr3lote, file }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Importando extrato", indeterminate: true }, { root: true })
			let formData = new FormData()
			formData.append("file", file)
			formData.append("dr3lote", dr3lote)
			let payload = await this._vm.$axios
				.post("/Financial/LaunchBatch/ImportBankStatement", formData, { headers: { "Content-Type": "multipart/form-data" } })
				.then(response => Utils.ValidateAxiosResponse(response.data))
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			if (payload && payload.length) {
				commit("appendImportedLines", payload)
			} else if (payload) {
				dispatch("parameters/openDialog", {
					titleText: "Aviso",
					titleColor: "#f8bb86",
					text: "Nenhum lançamento do extrato na data contábil do lote.",
				}, { root: true })
			}
			return payload
		},
	},
}
